import moment from 'moment-timezone';
import 'moment/locale/zh-hk';

moment.locale('zh-hk');
moment.tz.setDefault('Asia/Hong_Kong');

export default moment;
